import React from "react";
import "./ui.scss";

const Avatar: React.FC<{ name: string }> = ({ name }) => {
  const initials = name
    .split(" ")
    .map(part => (part[0] ? part[0].toUpperCase() : ""))
    .slice(0, 2)
    .join("");
  return <span className="avatar" aria-hidden>{initials || "?"}</span>;
};

export default Avatar;


